<template>
  <div>Төрийн үйлчилгээний судалгаа</div>
</template>
<script>
export default {};
</script>
